module.exports = __webpack_public_path__ + "files/23da647d4f824a16a729b33265e1130f.svg";